<!-- 现场管理人员详情 -->
<template>
	<div class="projectDetail-container">
		<div class="projectDetail-content">
			<div class="tab-container mt20">
				<div class="cjt-tabs">
					<div class="cjt-tabs__content pdm20">
						<div class="qualificationQuery-search">
							<el-form :model="searchForm" ref="searchForm" label-width="150px" class="searchForm">
								<el-form-item label="姓名：" prop="name">
									<el-input v-model="searchForm.name" placeholder="请输入企业名称"></el-input>
								</el-form-item>
								<el-form-item label="人员类型：" prop="region">
									<el-input v-model="searchForm.name" placeholder="请输入统一信用代码"></el-input>
								</el-form-item>
							</el-form>
							<div class="search-button-box">
								<el-button class="search">查询</el-button>
								<el-button class="reset">重置</el-button>
							</div>
						</div>
						<div class="register-table mt20">
							<el-table
								:data="registerList"
								size="medium"
								style="width: 100%;border: 1px solid #bad6f0;"
								:header-cell-style="{
									background: '#dceaf7',
									color: '#1f5d99',
									height: '50px',
									padding: '0px',
									borderBottom: '1px solid #bad6f0'
								}"
								row-class-name="table-row"
							>
								<el-table-column type="index" label="序号" align="center"></el-table-column>
								<el-table-column prop="certificateNo" label="证书名称" align="center"></el-table-column>
								<el-table-column prop="qualificationName" label="注册单位" align="center"></el-table-column>
								<el-table-column prop="issueDate" label="注册专业" align="center"></el-table-column>
								<el-table-column prop="expiryDate" label="注册日期" align="center"></el-table-column>
								<el-table-column prop="issuingAuthority" label="有效期" align="center"></el-table-column>
								<el-table-column prop="bz" label="备注" align="center"></el-table-column>
							</el-table>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'PersonnelDetails',
		components: {},
		props: {},
		data() {
			return {
				searchForm: {
					name: '',
					region: ''
				},
				detailInfo: {}
			}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {},
		methods: {}
	}
</script>

<style lang="scss" scoped>
	.tab-container {
		width: 100%;
		padding: 0px 20px 0px 20px;
		background: #fff;
		.pagination-container {
			padding-top: 9px;
			padding-bottom: 12px;
		}
	}
	.project-table {
		margin-top: 20px;
		background-color: #fff;
		border-radius: 6px;
		overflow: hidden;
		padding-bottom: 20px;
		.table-title {
			width: 100%;
			padding: 15px 20px;
			background-color: #e8f4f9;
			font-size: 18px;
			font-weight: bold;
			color: #333;
			border: 1px solid #c9c9c9;
			border-bottom: none;
			border-radius: 6px 6px 0 0;
			text-align: center;
		}
		table {
			width: 100%;
			border-collapse: separate;
			border-spacing: 0;
			border: 1px solid #c9c9c9;
			border-radius: 6px;
			background-color: #ffffff;
			overflow: hidden;
			table-layout: fixed; // 添加这行

			&:not(:last-child) {
				border-bottom-left-radius: 0;
				border-bottom-right-radius: 0;
			}

			tr {
				&:not(:last-child) {
					border-bottom: 1px solid #c9c9c9;
				}
			}

			th,
			td {
				padding: 15px 20px;
				text-align: left;
				font-size: 16px;
				border-bottom: 1px solid #c9c9c9;
			}

			tr:last-child {
				th,
				td {
					border-bottom: none;
				}
			}
			th {
				width: 180px;
				background-color: #e8f4f9;
				color: #333;
				font-weight: 500;
				border-right: 1px solid #c9c9c9;
			}

			td {
				width: calc(33.33% - 180px);
				color: #666;
				line-height: 1.6;

				&:not(:last-child) {
					border-right: 1px solid #c9c9c9;
				}
			}
		}

		.expand-more {
			text-align: center;
			padding: 10px 0;
			color: #4686d2;
			cursor: pointer;
			transition: all 0.3s;
			background-color: #ffffff;
			border: 1px solid #c9c9c9;
			border-top: none;
			border-bottom-left-radius: 6px;
			border-bottom-right-radius: 6px;

			&:hover {
				background-color: #e8f4f9;
			}

			span {
				margin-right: 5px;
			}
		}

		.more-fields {
			margin-top: -4px;

			table {
				border-top-left-radius: 0;
				border-top-right-radius: 0;
			}
		}
	}
	.bt-table {
		table {
			border-top-left-radius: 0px;
			border-top-right-radius: 0px;
			th {
				width: 190px;
			}
			td {
				width: calc(33.33% - 190px);
			}
		}
	}
	.el-form-item {
		width: 590px;
	}
</style>
